import { Popover, Space } from 'antd'
import { FC } from 'react'
import { RotatedTitle } from '../../../../components/rotated-title/rotated-title'
import CalculationPosition from '../../../../types/api/calculation-position'
import CalculationLacquersSelect from '../../components/calculation-form/components/form-items/calculation-lacquers-select'
import { onCellUnlessColorProofDurstRollout } from '../../helpers/color-proof-branch'
import { renderCalcPos } from '../../helpers/helpers'
import type { CalculationColumn } from '../../types/column-types'

export const lacquersColumn: CalculationColumn = {
    dataIndex: 'lacquers',
    title: <RotatedTitle>Лак</RotatedTitle>,
    width: 30,
    editable: true,
    fieldDescriptors: [
        {
            name: 'lacquers',
            getValue: (record: CalculationPosition) =>
                record.lacquers
                    ?.map(l => l.type?.documentId)
                    .filter((id): id is string => Boolean(id)) ?? [],
        },
    ],
    FormItem: <CalculationLacquersSelect />,
    render: renderCalcPos(r => <LacquersCellCount record={r} />),
    onCell: onCellUnlessColorProofDurstRollout,
}

const LacquersCellCount: FC<{ record: CalculationPosition }> = ({ record }) => {
    const list = record.lacquers
    if (!list?.length) {
        return <>{record.varnish || ''}</>
    }

    return (
        <Popover
            content={
                <Space direction='vertical'>
                    {list.map(x => (
                        <span key={x.id ?? x.type?.documentId}>{x.type?.name}</span>
                    ))}
                </Space>
            }
        >
            {list.length}
        </Popover>
    )
}
